import React, { createContext, useContext, useState } from 'react';

const QuickViewContext = createContext();

export const QuickViewProvider = ({ children }) => {
  const [isQuickViewModalOpen, setIsQuickViewModalOpen] = useState(false);
  const [productToQuickView, setProductToQuickView] = useState(null);

  const openQuickViewModal = (product) => {
    setProductToQuickView(product);
    setIsQuickViewModalOpen(true);
  };

  const closeQuickViewModal = () => {
    setIsQuickViewModalOpen(false);
    setProductToQuickView(null);
  };

  return (
    <QuickViewContext.Provider value={{
      isQuickViewModalOpen,
      productToQuickView,
      openQuickViewModal,
      closeQuickViewModal
    }}>
      {children}
    </QuickViewContext.Provider>
  );
};

export const useQuickView = () => {
  const context = useContext(QuickViewContext);
  if (!context) {
    throw new Error('useQuickView must be used within a QuickViewProvider');
  }
  return context;
};
